/** @format */

import { nu64, struct, u8 } from "@solana/buffer-layout";
import { useWalletModal } from "@solana/wallet-adapter-ant-design";
import {
  SendTransactionOptions,
  WalletNotConnectedError,
} from "@solana/wallet-adapter-base";
import { useWallet } from "@solana/wallet-adapter-react";
import * as web3 from "@solana/web3.js";
import { Transaction } from "@solana/web3.js";
import { deserializeUnchecked } from "borsh";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import beer from "../../../assets/images/pong/beer.png";
import smuBall from "../../../assets/images/pong/smu-ball.png";
import { GameInstructions } from "../GameInstruction/GameInstructions";
import {
  BigButton,
  ButtonWrapper,
  Container,
  HeroImage,
  Root,
  RoundButton,
  RoundButtonBig,
  SubTitle,
  Title,
} from "./styles";

class Assignable {
  constructor(properties: { [x: string]: any }) {
    Object.keys(properties).map((key) => {
      // @ts-ignore
      return (this[key] = properties[key]);
    });
  }
}

export class AccountData extends Assignable {}

const dataSchema = new Map([
  [
    AccountData,
    {
      kind: "struct",
      fields: [
        ["cup", "u64"],
        ["staker", [32]],
        ["active", "u8"],
        ["sols_amount", "u64"],
      ],
    },
  ],
]);

export async function getAccountData(
  connection: { getAccountInfo: (arg0: any) => any },
  account: any
) {
  let nameAccount = await connection.getAccountInfo(account);
  if (!nameAccount?.data) return null;
  let result = deserializeUnchecked(dataSchema, AccountData, nameAccount.data);

  return result
    ? {
        cup: result.cup.toNumber(),
        sols_amount: result.sols_amount.toNumber(),
        staker: new web3.PublicKey(result.staker).toString(),
        active: !!result.active,
      }
    : null;
}

let program_id = new web3.PublicKey(
  "BuQrcqRNgUXSzrjGGCSgE5idt6ihfd9E2dkdmsWjwGtL"
  // "EngcnJzWVXsYmGP8Fp3ANsJJmAUHZnL8uXU6h4CiNsKV"
);
let admin_key = new web3.PublicKey(
  "GeTZF747qhmVNFYcQY1MMubw5ZaFih5i8H221c2tFnUc"
);

let rent = new web3.PublicKey("SysvarRent111111111111111111111111111111111");

let connection = new web3.Connection(
  // web3.clusterApiUrl('mainnet-beta'),
  "https://mainnet.helius-rpc.com/?api-key=fbbf2be7-46aa-4b16-a6ff-3b9679694f75",
  "confirmed"
);

// main ground
export const PongGround = () => {
  const [playAmount, setPlayAmount] = useState<number>(0);
  const [state, setState] = useState<string>(
    sessionStorage.getItem("state") as string
  );
  // const [state, setState] = useState<string>(
  //   sessionStorage.getItem('state') as string
  // );
  const { setVisible: setOpenWalletModal } = useWalletModal();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(0);
  const [openInstruction, setOpenInstruction] = useState(false);
  const [stake_data, set_stake_data] = useState<any>(null);
  const { publicKey, sendTransaction, connected } = useWallet();

  const enrollInstructions = async (publicKey: {
    toBuffer: () => Buffer | Uint8Array;
  }) => {
    if (!publicKey) throw new WalletNotConnectedError();

    let [stake_dataPda] = await web3.PublicKey.findProgramAddress(
      [publicKey.toBuffer()],
      program_id
    );

    var split_enc = new TextEncoder().encode("split");
    const [split_pda] = await web3.PublicKey.findProgramAddress(
      [split_enc],
      program_id
    );
    let keys = [
      { pubkey: publicKey, isSigner: true, isWritable: true },
      { pubkey: split_pda, isSigner: false, isWritable: true },
      {
        pubkey: web3.SystemProgram.programId,
        isSigner: false,
        isWritable: false,
      },
      { pubkey: rent, isSigner: false, isWritable: false },
      { pubkey: stake_dataPda, isSigner: false, isWritable: true },
    ];

    //@ts-ignore
    const commandDataLayout = struct([u8("instruction")]);

    let data = Buffer.alloc(1024);
    {
      const encodeLength = commandDataLayout.encode(
        {
          instruction: 1, //Check the instruction number
          // amount,
          // lock_period,
        },
        data
      );
      data = data.slice(0, encodeLength);
    }

    // console.log("program_Id", program_id.toString())

    return new web3.TransactionInstruction({
      // @ts-ignore
      keys,
      programId: program_id,
      data,
    });
  };
  const canWithdraw = useMemo(
    () => !!publicKey?.equals(admin_key),
    [publicKey]
  );
  const withdraw = async (
    publicKey: web3.PublicKey,
    sendTransaction: {
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (arg0: web3.Transaction, arg1: web3.Connection): any;
    }
  ) => {
    const claimToast = toast.loading("Withdrawing Payment...");
    if (!publicKey) throw new WalletNotConnectedError();
    if (!admin_key.equals(publicKey)) throw new WalletNotConnectedError();

    let [split_pda] = await web3.PublicKey.findProgramAddress(
      [new TextEncoder().encode("split")],
      program_id
    );

    let keys = [
      { pubkey: admin_key, isSigner: true, isWritable: true },
      { pubkey: split_pda, isSigner: false, isWritable: true },
      {
        pubkey: web3.SystemProgram.programId,
        isSigner: false,
        isWritable: false,
      },
      { pubkey: rent, isSigner: false, isWritable: false },
    ];

    let transaction = new Transaction({
      feePayer: publicKey,
    });

    //@ts-ignore
    const commandDataLayout = struct([u8("instruction")]);

    let data = Buffer.alloc(1024);
    {
      const encodeLength = commandDataLayout.encode(
        {
          instruction: 5, //Check the instruction number
        },
        data
      );
      data = data.slice(0, encodeLength);
    }

    transaction.add(
      new web3.TransactionInstruction({
        // @ts-ignore
        keys,
        programId: program_id,
        data,
      })
    );

    try {
      const signature = await sendTransaction(transaction, connection, {
        skipPreflight: true,
      });

      const result = await connection.confirmTransaction(
        signature,
        "processed"
      );
      if (result.value.err) {
        console.error(result.value.err);
        toast.update(claimToast, {
          render: "Failed to withdraw",
          type: "error",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
      } else {
        toast.update(claimToast, {
          render: "Successfully Withdrawn!",
          type: "success",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
      }
    } catch (e) {
      console.error(e);
      toast.update(claimToast, {
        render: "Failed to claim",
        type: "error",
        position: "bottom-left",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
        closeButton: true,
      });
    }
  };

  const claim = async (
    publicKey: web3.PublicKey,
    sendTransaction: {
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (arg0: web3.Transaction, arg1: web3.Connection): any;
    }
  ) => {
    const claimToast = toast.loading("Claiming Payment...");
    if (!publicKey) throw new WalletNotConnectedError();

    let [stake_dataPda] = await web3.PublicKey.findProgramAddress(
      [publicKey.toBuffer()],
      program_id
    );

    var split_enc = new TextEncoder().encode("split");
    const [split_pda] = await web3.PublicKey.findProgramAddress(
      [split_enc],
      program_id
    );

    let keys = [
      { pubkey: publicKey, isSigner: true, isWritable: true },
      { pubkey: split_pda, isSigner: false, isWritable: true },
      {
        pubkey: web3.SystemProgram.programId,
        isSigner: false,
        isWritable: false,
      },
      { pubkey: rent, isSigner: false, isWritable: false },
      { pubkey: stake_dataPda, isSigner: false, isWritable: true },
    ];

    let transaction = new Transaction({
      feePayer: publicKey,
    });

    const commandDataLayout = struct([
      //@ts-ignore
      u8("instruction"),
      // nu64("amount"),
      // nu64("lock_period"),
    ]);

    let data = Buffer.alloc(1024);
    {
      const encodeLength = commandDataLayout.encode(
        {
          instruction: 3, //Check the instruction number
          // amount,
          // lock_period,
        },
        data
      );
      data = data.slice(0, encodeLength);
    }

    transaction.add(
      new web3.TransactionInstruction({
        // @ts-ignore
        keys,
        programId: program_id,
        data,
      })
    );

    try {
      const signature = await sendTransaction(transaction, connection);

      const result = await connection.confirmTransaction(
        signature,
        "processed"
      );
      if (result.value.err) {
        toast.update(claimToast, {
          render: "Failed to claim",
          type: "error",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
      } else {
        toast.update(claimToast, {
          render: "Successfully Claimed!",
          type: "success",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
        setState("1");
        set_stake_data({ ...stake_data, cup: 0 });
        sessionStorage.setItem("state", "1");
      }
    } catch (e) {
      console.clear()
      console.error(e);
      toast.update(claimToast, {
        render: "Failed to claim",
        type: "error",
        position: "bottom-left",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
        closeButton: true,
      });
    }
  };

  const play = async (
    amount: number,
    publicKey: web3.PublicKey,
    sendTransaction: {
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (
        transaction: web3.Transaction,
        connection: web3.Connection,
        options?: SendTransactionOptions | undefined
      ): Promise<string>;
      (arg0: web3.Transaction, arg1: web3.Connection): any;
    }
  ) => {
    // @ts-ignore
    const payToast = toast.loading("Confirming Payment...");
    const currentCup = stake_data?.cup || 0;
    if (loading) return;
    if (!publicKey) throw new WalletNotConnectedError();
    if (!amount)
      // amount = parseFloat(prompt("What amount? [0.1, 0.25, 0.5, 1]", "0.1"));
      amount = parseFloat(String(playAmount));
    debugger;
    try {
      setLoading((l) => l + 1);

      let [pda_stake_data] = await web3.PublicKey.findProgramAddress(
        [publicKey.toBuffer()],
        program_id
      );

      var split_enc = new TextEncoder().encode("split");
      const [split_pda] = await web3.PublicKey.findProgramAddress(
        [split_enc],
        program_id
      );

      let keys = [
        { pubkey: publicKey, isSigner: true, isWritable: true },
        { pubkey: split_pda, isSigner: false, isWritable: true },
        {
          pubkey: web3.SystemProgram.programId,
          isSigner: false,
          isWritable: false,
        },
        { pubkey: rent, isSigner: false, isWritable: false },
        { pubkey: pda_stake_data, isSigner: false, isWritable: true },
      ];
      keys.forEach(({ pubkey }, i) => {
        console.log(pubkey.toString(), i);
      });
      let transaction = new Transaction({
        feePayer: publicKey,
      });

      //@ts-ignore
      const commandDataLayout = struct([u8("instruction"), nu64("amount")]);
      // console.log(amount,amount * web3.LAMPORTS_PER_SOL,)

      let data = Buffer.alloc(1024);
      const encodeLength = commandDataLayout.encode(
        {
          instruction: 2, //Check the instruction number
          amount: amount * web3.LAMPORTS_PER_SOL,
        },
        data
      );
      data = data.slice(0, encodeLength);
      console.log(stake_data, !stake_data);
      if (!stake_data)
        transaction.add(await enrollInstructions(publicKey));
      transaction.add(
        new web3.TransactionInstruction({
          // @ts-ignore
          keys,
          programId: program_id,
          data,
        })
      );
      const signature = await sendTransaction(transaction, connection, {
        skipPreflight: true,
      });
      // console.log("sig", signature)

      const result = await connection.confirmTransaction(
        signature,
        "confirmed"
      );
      // console.log("Failed to make payment", result.value.err)
      setLoading((l) => l - 1);
      if (result.value.err) {
        toast.update(payToast, {
          render: "Failed to make payment",
          type: "error",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
      } else {
        toast.update(payToast, {
          render: "Payment confirmed",
          type: "success",
          position: "bottom-left",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          closeButton: true,
        });
        const logic = await fetchLogic();
        console.log("currentCup or logic cup", currentCup, logic?.cup);
        if (!currentCup && logic?.cup) {
          navigate(`/confirmed?transaction=1&${publicKey}`);
        } else if (logic?.cup > currentCup) {
          navigate(`/confirmed?transaction=1&${publicKey}`);
        } else {
          navigate(`/confirmed?transaction=0&${publicKey}`);
        }
      }
    } catch (e) {
      setLoading((l) => l - 1);
      console.clear()
      console.error(e);
      toast.update(payToast, {
        render: "Something went wrong",
        type: "error",
        isLoading: false,
        closeOnClick: true,
        closeButton: true,
      });
    }
  };

  const fetchLogic = useCallback(async () => {
    if (!publicKey) return;

    setLoading((l) => l + 1);
    try {
      let [pda_stake_data] = await web3.PublicKey.findProgramAddress(
        [publicKey.toBuffer()],
        program_id
      );
      const data = await getAccountData(connection, pda_stake_data);
      set_stake_data(data);
      setLoading((l) => l - 1);
      return data;
    } catch (e) {
      console.error(e);
      setLoading((l) => l - 1);
      return null;
    }
  }, [publicKey]);

  useEffect(() => {
    fetchLogic();
  }, [publicKey, fetchLogic]);

  useEffect(() => {
    // console.log(stake_data)
    if (!stake_data) setState("1");
    else if (
      stake_data?.cup == 0 &&
      stake_data?.sols_amount == 0 &&
      state == "1"
    )
      return;
    else if (
      stake_data?.cup == 0 &&
      stake_data?.sols_amount > 0 &&
      state == "1"
    )
      return;
    else if (stake_data?.cup == 0 && stake_data?.sols_amount == 0)
      setState("5");
    else if (stake_data?.cup == 0 && stake_data?.sols_amount > 0) setState("5");
    else if (stake_data?.cup == 0) setState("1");
    else if (stake_data?.cup == 2 && stake_data?.sols_amount > 0) setState("3");
    else if (stake_data?.cup == 2) setState("5");
    else setState("4");
  }, [stake_data]);

  // useEffect(() => {
  //   if (stake_data?.cup === 3) {
  //     setState('3');
  //     sessionStorage.setItem('state', '3');
  //   }
  // });

  const handleStarting = async () => {
    const playRule = localStorage.getItem("playRule");
    // console.log(playRule !== 'true');
    if (publicKey && connected) {
      if (playRule !== "true" || playRule === null) {
        setOpenInstruction(true);
      } else {
        setState("2");
      }
    } else {
      setOpenWalletModal(true);
      // if (playRule === 'false') {
      //   setOpenInstruction(true);
      // } else {
      //   setState('2');
      // }
    }
  };

  return (
    <Container>
      {publicKey ? (
        <Root>
          {canWithdraw && (
            <ButtonWrapper>
              <RoundButtonBig
                whileHover={{ scale: 1.1 }}
                onClick={() => {
                  withdraw(publicKey, sendTransaction);
                }}
              >
                Withdraw Funds
              </RoundButtonBig>
            </ButtonWrapper>
          )}
          {state === "1" ? (
            <>
              <>
                <HeroImage
                  animate={{ y: [-5, 5, -5, 5, -5] }}
                  transition={{
                    type: "spring",
                    repeat: Infinity,
                    duration: 5,
                  }}
                  src={beer}
                  alt="beer"
                />
                <BigButton whileHover={{ scale: 1.1 }} onClick={handleStarting}>
                  Click to play
                </BigButton>
              </>
            </>
          ) : state === "2" ? (
            <>
              <HeroImage
                animate={{ y: [-5, 5, -5, 5, -5] }}
                transition={{
                  type: "spring",
                  repeat: Infinity,
                  duration: 3,
                }}
                src={smuBall}
                alt="smu-ball"
              />
              <Title>
                {stake_data?.cup === 0
                  ? "First"
                  : stake_data?.cup === 1
                  ? "Second"
                  : ""}{" "}
                Throw
              </Title>{" "}
              <SubTitle>Choose your bet</SubTitle>
              {publicKey && stake_data?.cup > 2 ? (
                <ButtonWrapper>
                  {publicKey && (
                    <RoundButtonBig
                      whileHover={{ scale: 1.1 }}
                      onClick={() => {
                        claim(publicKey, sendTransaction);
                      }}
                    >
                      Cash Out
                    </RoundButtonBig>
                  )}
                </ButtonWrapper>
              ) : (
                <ButtonWrapper>
                  <RoundButton
                    whileHover={{ scale: 1.1 }}
                    onClick={() => {
                      play(0.05, publicKey, sendTransaction);
                      setPlayAmount(0.05);
                    }}
                  >
                    0.05
                  </RoundButton>
                  <RoundButton
                    whileHover={{ scale: 1.1 }}
                    onClick={() => {
                      play(0.25, publicKey, sendTransaction);
                      setPlayAmount(0.25);
                    }}
                  >
                    0.25
                  </RoundButton>
                  <RoundButton
                    whileHover={{
                      scale: 1.1,
                    }}
                    onClick={() => {
                      play(0.5, publicKey, sendTransaction);
                      setPlayAmount(0.5);
                    }}
                  >
                    0.5
                  </RoundButton>
                  <RoundButton
                    whileHover={{
                      scale: 1.1,
                    }}
                    onClick={() => {
                      play(0.75, publicKey, sendTransaction);
                      setPlayAmount(0.75);
                    }}
                  >
                    0.75
                  </RoundButton>
                  <RoundButton
                    whileHover={{
                      scale: 1.1,
                    }}
                    onClick={() => {
                      play(1, publicKey, sendTransaction);
                      setPlayAmount(1);
                    }}
                  >
                    1.0
                  </RoundButton>
                  <RoundButton
                    whileHover={{
                      scale: 1.1,
                    }}
                    onClick={() => {
                      play(2, publicKey, sendTransaction);
                      setPlayAmount(2);
                    }}
                  >
                    2.0
                  </RoundButton>
                </ButtonWrapper>
              )}
            </>
          ) : state === "3" ? (
            <>
              <HeroImage
                animate={{ y: [-5, 5, -5, 5, -5] }}
                transition={{
                  type: "spring",
                  repeat: Infinity,
                  duration: 5,
                }}
                src={smuBall}
                alt="smu-ball"
              />
              <Title>CONGRATULATIONS!</Title>
              <SubTitle>Cash out to end the game</SubTitle>

              {publicKey && (
                <ButtonWrapper>
                  <RoundButtonBig
                    whileHover={{ scale: 1.1 }}
                    onClick={() => {
                      claim(publicKey, sendTransaction);
                    }}
                  >
                    Cash Out
                  </RoundButtonBig>
                </ButtonWrapper>
              )}
            </>
          ) : state === "4" ? (
            <>
              <HeroImage
                animate={{ y: [-5, 5, -5, 5, -5] }}
                transition={{
                  type: "spring",
                  repeat: Infinity,
                  duration: 5,
                }}
                src={smuBall}
                alt="smu-ball"
              />
              <Title>DOUBLE OR NOTHING?</Title>
              <SubTitle>
                Double or nothing to continue playing / Cash out to end the game
              </SubTitle>
              {publicKey ? (
                <ButtonWrapper>
                  <RoundButtonBig
                    whileHover={{ scale: 1.2 }}
                    onClick={() =>
                      play(
                        stake_data?.cup && stake_data?.sols_amount / 10 ** 9,
                        publicKey,
                        sendTransaction
                      )
                    }
                  >
                    DOUBLE
                  </RoundButtonBig>

                  <RoundButtonBig
                    whileHover={{ scale: 1.1 }}
                    onClick={() => {
                      claim(publicKey, sendTransaction);
                    }}
                  >
                    CASH OUT
                  </RoundButtonBig>
                </ButtonWrapper>
              ) : (
                ""
              )}
            </>
          ) : state === "5" ? (
            <>
              <HeroImage
                animate={{ y: [-5, 5, -5, 5, -5] }}
                transition={{
                  type: "spring",
                  repeat: Infinity,
                  duration: 5,
                }}
                src={smuBall}
                alt="smu-ball"
              />
              <Title>You Lost!</Title>
              <SubTitle>Let's try again</SubTitle>
              {publicKey && (
                <ButtonWrapper>
                  <RoundButtonBig
                    whileHover={{ scale: 1.1 }}
                    onClick={() => {
                      setState("1");
                      window.sessionStorage.setItem("state", "1");
                    }}
                  >
                    Try Again
                  </RoundButtonBig>
                </ButtonWrapper>
              )}
            </>
          ) : (
            ""
          )}
        </Root>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <HeroImage
            animate={{ y: [-5, 5, -5, 5, -5] }}
            transition={{
              type: "spring",
              repeat: Infinity,
              duration: 5,
            }}
            src={beer}
            alt="beer"
          />
          <BigButton whileHover={{ scale: 1.1 }} onClick={handleStarting}>
            Click to play
          </BigButton>
        </div>
      )}
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {openInstruction && (
        <GameInstructions
          isOpen={openInstruction}
          handleClose={() => {
            setOpenInstruction(false);
            setState("2");
          }}
        />
      )}
    </Container>
  );
};
